import { Box, DialogContent, Modal, useTheme } from '@mui/material';
import { dialogContentSx, iconBtnSx, modalBoxSx } from './ModalContainer.style';
import { Close } from '../../icons/Close/Close';
import { IconBtn } from '../../components/IconBtn/IconBtn';
import { flexCenterSx } from '../../styles/Global.style';

export const ModalContainer = ({
  children,
  isOpen,
  onClose,
  dialogContentOverrideSx,
}) => {
  const theme = useTheme();

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      closeAfterTransition
      sx={flexCenterSx}
    >
      <Box sx={modalBoxSx(theme)}>
        <IconBtn
          icon={<Close />}
          onClick={onClose}
          color={theme.palette.secondary.main}
          sx={iconBtnSx}
        />
        <DialogContent sx={{ ...dialogContentSx, ...dialogContentOverrideSx }}>
          {children}
        </DialogContent>
      </Box>
    </Modal>
  );
};
